
import { LinkedInChildApplicationResponse } from "../../models/linkedin-manager/LinkedInChildApplicationResponse";
import { BaseService } from "../BaseService";

export class LinkedInService
    extends BaseService {
    /**
    * Gets the LinkedIn child application of a company
    * 
    */
    async GetLinkedInChildApplicationByCompanyId(companyId?: number) {
        const linkedInChildApplication = await this.Get<LinkedInChildApplicationResponse>(`/linkedin-child-application/${companyId}`);
        return linkedInChildApplication;
    }
}

const linkedinService = new LinkedInService("LinkedIn");
export default linkedinService